(function ($) {
    var $body = $('body'),
        $header = $('header'),
        $headerWrapper = $(".header__wrapper"),
        $searchbarHeader = $('header .searchbar-header'),
        $searchField = $searchbarHeader.find('input[type="search"]'),
        $searchbarClose = $searchbarHeader.find('.searchbar-close'),
        $searchSubmit = $('.search-submit'),
        $searchToggle = $('.search-toggle'),
        $searchbarToggle = $('.search-toggle-button'),
        $searchToggleDashboard = $('.search-toggle-dashboard'),
        $cookieBanner = $(".cookie-banner"),
        $informaRibbon = $(".informa-ribbon"),
        $sidebarNavigation = $("#sidebar-navigation"),
        $sidebarNavigationScrollbar = $(".sidebar-navigation-scrollbar"),
        $main = $("main");
        
    // Mobile detection
    const isMobileView = () => window.visualViewport.width <= 800;

    var $removeSearchActive, $ribbonHeight = 0;

    function updateRibbonHeight() {
        if ($cookieBanner.hasClass("is-visible")) {
            $ribbonHeight = $cookieBanner.height() + $informaRibbon.height();
        } else if ($informaRibbon && $informaRibbon.length > 0) {
            $ribbonHeight = $informaRibbon.height();
        } else {
			$ribbonHeight = 0;
		}
    }

    function hideSearchbarActive() {
        clearTimeout($removeSearchActive);
        $removeSearchActive = setTimeout(function () {
            $header.removeClass('search-active');
            $searchField.val("");
        }, 300);
    }

    function updateLayout() { 
        var scrollTop = $(window).scrollTop(); 
        updateRibbonHeight(); 
        if (scrollTop >= $ribbonHeight) { 
            $body.addClass('scrolled'); 
            $main.css({ 
                paddingTop: $headerWrapper.height() + $ribbonHeight - scrollTop 
            }); 
            $searchbarHeader.css({ 
                position: 'fixed', 
                top: $headerWrapper.height() - 1,
            });
            if(!isMobileView()) {
                $sidebarNavigation.css({ 
                    top: $headerWrapper.height() 
                });
            } else {
                $sidebarNavigation.css({ 
                    top: 0,
                });
            }
            $sidebarNavigationScrollbar.css({
                "height": 'calc(100vh - ' + $header.height()*2 + 'px)'
            })
        } else { 
            $body.removeClass('scrolled'); 
            $main.css({ paddingTop: 0 }); 
            $searchbarHeader.css({ 
                position: 'fixed', 
                top: ($headerWrapper.height() + $ribbonHeight - scrollTop) - 1
            });
            if(!isMobileView()) {
                $sidebarNavigation.css({ 
                    top: $header.height() - scrollTop 
                }); 
            } else {
                $sidebarNavigation.css({ 
                    top: $ribbonHeight - scrollTop,                    
                });
            }
            $sidebarNavigationScrollbar.css({
                "height": 'calc(100vh - ' + $header.height() + 'px)'
            })
        } 
    }

    // Submit search
    $searchSubmit.on('click', function (e) {
        e.preventDefault();
        $(e.currentTarget).closest('form').submit();
    });

    // Toggle search
    function toggleSearchActive(e) { 
        e.stopPropagation(); 
        clearTimeout($removeSearchActive); 
        $header.toggleClass('search-active'); 
        if ($searchField.length) { 
            if ($header.hasClass('search-active')) { 
                $searchField[0].focus(); 
            } else { 
                $searchField[0].blur(); 
                $searchField.val(""); 
            } 
        } 
    } 
    $searchToggle.on('click', toggleSearchActive);
    $searchbarToggle.on('click', toggleSearchActive);
    // $searchToggleDashboard.on('click', toggleSearchActive);

    // Close searchbar
    $searchbarClose.on('click', function () {
        hideSearchbarActive();
        
    });

    // Click outside search
    $(document).click(function(e){
        // if ($(e.target).closest('.search-toggle, .search-toggle-button, .searchbar-header, .search-toggle-dashboard').length === 0) {
        if ($(e.target).closest('.search-toggle, .search-toggle-button, .searchbar-header').length === 0) {
            hideSearchbarActive();
        }
    });

    $(function () {
        updateLayout(); // run once on load
    });

    $(window).on("scroll resize", updateLayout);
    $(document).on("click", function(){
		setTimeout(updateLayout, 500)
	});
    $(document).on("click", updateRibbonHeight);
})(Zepto);